import { render, staticRenderFns } from "./layout-default-header-lang-select.vue?vue&type=template&id=cf72eac2&"
import script from "./layout-default-header-lang-select.vue?vue&type=script&lang=js&"
export * from "./layout-default-header-lang-select.vue?vue&type=script&lang=js&"
import style0 from "./layout-default-header-lang-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports